import { Injectable, inject } from '@angular/core';
import { UserProfileDialogService } from '@interacta-shared/feature-caronte';
import { CommunitiesStateService } from '@interacta/data-access-community-tree';
import { adminFlush } from '@modules/core/store/app.actions';
import { userMentionClick } from '@modules/shared-v2/store/mentions.actions';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { tap } from 'rxjs';

@Injectable()
export class StateEffects {
    private actions$ = inject(Actions);
    private userProfileDialogService = inject(UserProfileDialogService);
    private communitiesStateService = inject(CommunitiesStateService);

    openProfilePreviewDialog$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(userMentionClick),
                tap(({ id }) =>
                    this.userProfileDialogService.openDialog({ id }),
                ),
            ),
        { dispatch: false },
    );

    adminFlush$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(adminFlush),
                tap(() => {
                    this.communitiesStateService.initializeCommunityTrees();
                    this.communitiesStateService.clearAdminCommunityTree();
                }),
            ),
        { dispatch: false },
    );
}
